const TabLogs = () => {
   return (
      <div>
         <div className="filter-logs">
            <div className="filter-growth-tool-container">
               <div className="filter-growth-tool-group">
                  <div className="filter-growth-tool-type filter-growth-tool-ctrl"><label>Loại:</label>
                     <div className="app-dropdown">
                        <div className="app-dropdown-wrap">
                           <div className="app-dropdown-selected font-size-14"><span className="app-dropdown-text-display">All</span>
                              <div className="app-dropdown-icon ">
                                 <svg ariaHidden="true" focusable="false" dataprefix="fas"
                                    dataicon="angle-down" className="svg-inline--fa fa-angle-down fa-w-10 fa-1x " role="img"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" color="rgba(0, 0, 0, .45)" style={{ width: 20, height: 16 }}>
                                    <path fill="currentColor"
                                       d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z">
                                    </path>
                                 </svg>
                              </div>
                           </div>
                           <div className="app-dropdown-list-container">
                              <div className="app-dropdown-list">
                                 <div className="app-dropdown-list-wrap">
                                    <div className="app-dropdown-item item-selected  " title="All">All</div>
                                    <div className="app-dropdown-item   " title="Inbox">Inbox</div>
                                    <div className="app-dropdown-item   " title="Comment">Comment</div>
                                    <div className="app-dropdown-item   " title="Dynamic">Dynamic</div>
                                    <div className="app-dropdown-item   " title="Đồng bộ sản phẩm">Đồng bộ sản phẩm</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="filter-growth-tool-ctrl"><label>Mã lỗi:</label>
                     <div>
                        <div className="app-dropdown">
                           <div className="app-dropdown-wrap">
                              <div className="app-dropdown-selected font-size-14"><span
                                 className="app-dropdown-text-display">All</span>
                                 <div className="app-dropdown-icon ">
                                    <svg ariaHidden="true" focusable="false" dataprefix="fas"
                                       dataicon="angle-down" className="svg-inline--fa fa-angle-down fa-w-10 fa-1x " role="img"
                                       xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" color="rgba(0, 0, 0, .45)" style={{ width: 20, height: 16 }}>
                                       <path fill="currentColor"
                                          d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z">
                                       </path>
                                    </svg>
                                 </div>
                              </div>
                              <div className="app-dropdown-list-container">
                                 <div className="app-dropdown-list">
                                    <div className="app-dropdown-list-wrap">
                                       <div className="app-dropdown-item item-selected  " title="All">All</div>
                                       <div className="app-dropdown-item   " title="2022">2022</div>
                                       <div className="app-dropdown-item   " title="10903">10903</div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div>
            <div className="">
               <div className="table-wrapper scroll-light over-x-unset">
                  <table className="app-v2-table ">
                     <thead className="app-v2-table-thead">
                        <tr className="app-v2-table-tr">
                           <th className="app-v2-table-th text-left-i" style={{ width: 120 }}>Mã lỗi</th>
                           <th className="app-v2-table-th text-left-i" style={{ width: 180 }}>Loại</th>
                           <th className="app-v2-table-th p-none-l text-left-i" style={{ width: 180 }}>Khách hàng</th>
                           <th className="app-v2-table-th p-none-l text-left-i">Mô tả</th>
                           <th className="app-v2-table-th p-none-l text-left-i" style={{ minWidth: 160 }}>Ngày</th>
                        </tr>
                     </thead>
                     <tbody className="app-v2-table-tbody">
                        <tr className="full-cols">
                           <td colSpan="42" className="text-center"><span className="text-note text-font-italic">Chưa có dữ
                              liệu.</span></td>
                        </tr>
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
      </div>
   )
}

export default TabLogs;